<script lang="ts">
	import type { PostSummary } from '$lib/types';
	import { formatDate, formatDateLong, getDateParts } from '$lib/utils/dates';
	import { groupPostsByYear } from '$lib/utils/timeline';

	export let posts: PostSummary[] = [];

	$: featured = posts[0] ?? null;
	$: earlier = posts.slice(1);
	$: groups = groupPostsByYear(earlier);
</script>

<section id="archive" class="archive" aria-label="Publications">
	{#if featured}
		<div class="container">
			<article class="featured">
				<p class="eyebrow">Latest</p>
				<a class="featured-link" href="/posts/{featured.slug}">
					{#if featured.date}
						<p class="featured-dateline">
							<time datetime={featured.date}>{formatDateLong(featured.date)}</time>
							<span class="meta-sep" aria-hidden="true">·</span>
							<span>{featured.readingMinutes} min read</span>
						</p>
					{/if}
					<h2 class="featured-title">{featured.title}</h2>
					{#if featured.excerpt}
						<p class="featured-excerpt">{featured.excerpt}</p>
					{/if}
					<span class="continue">
						Read the note
						<span aria-hidden="true">→</span>
					</span>
				</a>
			</article>
		</div>
	{/if}

	{#if earlier.length > 0 || !featured}
		<div class="container index-wrap">
			{#if earlier.length > 0}
				<div class="index-intro">
					<div class="section-intro">
						<h2 id="archive-heading">Earlier notes</h2>
						<div class="section-rule" aria-hidden="true"></div>
					</div>
				</div>

				{#each groups as group (group.year)}
					<section class="year-group" aria-labelledby={`year-${group.year}`}>
						<h3 class="year-heading" id={`year-${group.year}`}>{group.year}</h3>
						<ol class="index-list">
							{#each group.posts as post (post.slug)}
								<li class="index-item">
									<a class="index-entry" href="/posts/{post.slug}">
										{#if post.date}
											{@const parts = getDateParts(post.date)}
											<time class="index-date" datetime={post.date}>
												<span class="index-day">{parts.day}</span>
												<span class="index-month">{parts.month}</span>
												<span class="visually-hidden">{formatDate(post.date)}</span>
											</time>
										{:else}
											<span class="index-date" aria-hidden="true"></span>
										{/if}

										<div class="index-main">
											<h4 class="index-title">{post.title}</h4>
											{#if post.excerpt}
												<p class="index-excerpt">{post.excerpt}</p>
											{/if}
											<p class="index-meta">
												<span>{post.readingMinutes} min read</span>
												<span class="continue">
													Continue
													<span aria-hidden="true">→</span>
												</span>
											</p>
										</div>
									</a>
								</li>
							{/each}
						</ol>
					</section>
				{/each}
			{:else if !featured}
				<p class="empty-state">No publications available yet.</p>
			{/if}
		</div>
	{/if}
</section>
